// @ts-generator-hash: c7f1182dc0f5568e74e098c9314019e693b5106b18a202972aa7bd9b1798b230
// Generation date: 12/18/2025 11:03:23 PM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.NotificationTrigger
export enum NotificationTrigger {
  OnUpload = 1,
  OnStatusChange = 2,
  OnComment = 3,
}
